(function () {


	angular.module('app.widgets')
	.directive('plaCompare', plaCompare); 

	function plaCompare() {
        return {
            require: 'ngModel',
            link: function (scope, currentEl, attrs, ctrl) {
                var comparefield = document.getElementsByName(attrs.plaCompare)[0]; //getting first element
                compareEl = angular.element(comparefield);
            
                //current field key up
                currentEl.on('keyup', function () {
                if (compareEl.val() != "") {
                    var isMatch = currentEl.val() === compareEl.val();
                    ctrl.$setValidity('compare', isMatch);
                    scope.$digest();
                }
                });

                //Element to compare field key up
                compareEl.on('keyup', function () {
                    if (currentEl.val() != "") {
                    var isMatch = currentEl.val() === compareEl.val();
                    ctrl.$setValidity('compare', isMatch);
                    scope.$digest();
                    }
                });
                }
            }
    }

})();